<template>
    <div v-if="estate.energy_data.certification_type" class="row border-radius bg-white padding-flex mb-1">
        <div class="col-md-12 estate-energy-data">
            <h2>
                <masked-image class="icon_title" src="/img/icons/energy-data.svg" />
                {{ trans('labels.energy_data') | capitalize }}
            </h2>

            <div class="row" :class="version == 1 ? 'italia' : 'esteri'">
                <div class="energy-graph" :class="{ exempt: isExempt | isPending }">
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'a' }">
                        <span>{{ estate.energy_data.class | capitalize}}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'b' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'c' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'd' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'e' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'f' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'g' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'h' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                    <div class="square" :class="{ active: estate.energy_data.class.charAt(0).toLowerCase() == 'i' }">
                        <span>{{ estate.energy_data.class | capitalize }}</span>
                    </div>
                </div>

                <div
                    v-if="!isExempt & !isPending"
                    class="estate-energy-details mt-1"
                    :class="version == 1 ? 'col-md-12 col-lg-6' : 'col-md-6 col-lg-6'"
                >
                    <div class="energy-class" >
                        <div class="row">
                            <template v-if="certificationType === 'ape'">
                                <template v-if="estate.energy_data.ep_nren">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.ep_nren') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.ep_nren"></strong>
                                    </div>
                                </template>

                                <template v-if="estate.energy_data.ep_ren">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.ep_ren') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.ep_ren"></strong>
                                    </div>
                                </template>

                                <template v-if="estate.energy_data.smile_ci">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.smile_ci') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.smile_ci"></strong>
                                    </div>
                                </template>

                                <template v-if="estate.energy_data.smile_ce">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.smile_ce') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.smile_ce"></strong>
                                    </div>
                                </template>

                                <template v-if="estate.energy_data.zero">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.zero') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.zero"></strong>
                                    </div>
                                </template>
                            </template>

                            <template v-if="certificationType === 'ace'">
                                <template v-if="estate.energy_data.efficiency">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.index') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.efficiency"></strong>
                                    </div>
                                </template>
                            </template>

                            <template v-if="['presente', 'présent'].includes(certificationType)">
                                <template v-if="estate.energy_data.efficiency">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.index') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.efficiency"></strong>
                                    </div>
                                </template>
                                <template v-if="estate.energy_data.icone_emissions || estate.energy_data.emissions">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.emissions') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <span v-html="estate.energy_data.icone_emissions"></span>
                                        <template v-if="estate.energy_data.emissions">
                                            <strong><span v-html="estate.energy_data.emissions"></span> <span v-html="trans('energy_data.emissions_unit')"></span></strong>
                                        </template>
                                    </div>
                                </template>
                                <template v-if="estate.energy_data.certification_number">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.certification_number') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.certification_number"></strong>
                                    </div>
                                </template>
                                <template v-if="estate.energy_data.certification_date">
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">{{ trans('energy_data.certification_date') }}:</div>
                                    <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                        <strong v-html="estate.energy_data.certification_date"></strong>
                                    </div>
                                </template>
                            </template>
                        </div>    
                    </div>
                </div>

                <div v-else-if="isExempt" class="col-md-12 col-lg-6 mt-1">
                    <strong>{{ trans('energy_data.exempt') }}</strong>
                </div>

                <div v-else-if="isPending" class="col-md-12 col-lg-6 mt-1">
                    <strong>{{ trans('energy_data.pending') }}</strong>
                </div>

                <div class="estate-dates mt-1" :class="version == 1 ? 'col-md-12 col-lg-6' : 'col-md-6 col-lg-6'">
                    <template v-for="(date, key) in estate.dates">
                        <div v-if="date" :key="key" class="row">
                            <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                {{ trans('dates.' + key) }}:
                            </div>

                            <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                                <strong v-html="date"></strong>
                            </div>
                        </div>
                    </template>

                    <div v-if="estate.energy_data.heating" class="row">
                        <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                            {{ trans('energy_data.heating') }}:
                        </div>

                        <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                            <strong v-html="estate.energy_data.heating"></strong>
                        </div>
                    </div>

                    <div v-if="estate.energy_data.heating_type" class="row">
                        <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                            {{ trans('energy_data.heating_type') }}:
                        </div>

                        <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                            <strong v-html="estate.energy_data.heating_type"></strong>
                        </div>
                    </div>

                    <div v-if="estate.energy_data.heating_power" class="row">
                        <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                            {{ trans('energy_data.heating_power') }}:
                        </div>

                        <div class="col-sm-6 col-md-6 col-lg-12 col-xl-6">
                            <strong v-html="estate.energy_data.heating_power"></strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        estate: {
            type: Object,
            required: true,
        },

        version: {
            type: Number,
            required: true,
        },
    },

    computed: {
        certificationType() {
            return this.estate.energy_data.certification_type ? this.estate.energy_data.certification_type.toLowerCase() : null
        },

        isExempt() {
            return ['esente', 'exento', 'exempt', 'nincs'].includes(this.certificationType.toLowerCase())
        },

        isPending() {
            return ['tramitaci', 'folyamatban'].includes(this.certificationType.toLowerCase())
        },

        lang() {
            return this.$root.lang.estate_detail
        },
    },
}
</script>